// Auto generated file, do not manually modify!
// com.hotpads.rentguarantee.client.enums.RentGuaranteeExperimentVariation

export enum RentGuaranteeExperimentVariation {
  LOW_FRICTION = 'LOW_FRICTION',
  RACHEL_PAYS_OPT_IN_ARM_A = 'RACHEL_PAYS_OPT_IN_ARM_A',
  RACHEL_PAYS_OPT_IN_ARM_B = 'RACHEL_PAYS_OPT_IN_ARM_B',
}

export const RentGuaranteeExperimentVariation_values = [
  RentGuaranteeExperimentVariation.LOW_FRICTION,
  RentGuaranteeExperimentVariation.RACHEL_PAYS_OPT_IN_ARM_A,
  RentGuaranteeExperimentVariation.RACHEL_PAYS_OPT_IN_ARM_B,
] as const;
